import { useState } from "react";
import { useWebSocketConnection } from "../../services/connectionContext/connectionContext";
import { Button, Input } from "@mui/material";

export const SerialCommandSender = ({ socketUrl }) => {
    const { webSocketSend } = useWebSocketConnection();
    const [serialCommand, setSerialCommand] = useState('');

    const sendCommand = () => {
        // console.log("send serialCommand: " + serialCommand + " to the Broker:" + socketUrl);
        webSocketSend({ socketUrl: socketUrl, data: serialCommand });
        setSerialCommand('');
    }

    return (
        <>
            <Input value={serialCommand} onKeyPress={e => { if (e.key === "Enter") sendCommand() }}
                onChange={e => setSerialCommand(e.target.value)} />
            <Button disabled={serialCommand === '' ? true : false} onClick={sendCommand}>Send</Button>
        </>
    )
}
